
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites/[...favoritesUserSlug]",
      function () {
        return require("private-next-pages/favorites/[...favoritesUserSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favorites/[...favoritesUserSlug]"])
      });
    }
  